module.exports = __webpack_public_path__ + "img/dice-2.3b3316b6.svg";